import * as React from 'react';
import {IControlError, IControlSchema, ValidationResult} from "../../Controls";
import {Component, isNullOrEmpty, I18NString } from "../../Utils";
import {ApiClient} from "../../../services/ApiClient";
import {IDispatcher} from "../extensions/Dispatcher";
import Field from '../Field';
import { isEmpty } from 'lodash';
import Alert from './Alert'
import {Dictionary} from "../../../types/Dictionary";

export interface ICheckboxSchema extends IControlSchema {
    extra: {
        hint: string;
    };
    value?:string;
    disabled?: boolean;
    description: I18NString;
}

interface ICheckboxProps {
    schema: ICheckboxSchema;
    api: ApiClient;
    dispatcher?: IDispatcher;
    error: IControlError | undefined;
    visited: boolean;
}

interface ICheckboxState {
    isOpen: boolean;
}


class Checkbox extends Component<ICheckboxProps,ICheckboxState>{
    constructor(){
        super();
        this.onChange = this.onChange.bind(this);
        this.onClick = this.onClick.bind(this);
        this.state ={
            isOpen: false
        }
    }

    private checkbox: HTMLInputElement;

    onChange(e:any){
        const value = this.checkbox.checked ? "1" : null;

        const validationResult = this.validationResult(value);
        this.props.dispatcher.onBlur(this.props.schema.id, value, !validationResult, validationResult);
    }
    
    validationResult(value: string): ValidationResult | undefined {
        return undefined;
    }

    componentDidMount() {
        const { schema: {value}, error } = this.props;
        if(error) {
            return;
        }
        const validationResult = this.validationResult(value);
        this.props.dispatcher.onBlur(this.props.schema.id, value, !validationResult, validationResult);
    }

    onClick(){ this.setState({isOpen: !this.state.isOpen}); }

    render(){
        const { schema: {disabled, description, value}, visited, error } = this.props;
        const errorText = visited && error && error.message;

        return(
            <Field {...this.props.schema} status={isEmpty(value) ? "default" : "success" }>
                {this.props.schema.extra && this.props.schema.extra.hint && (
                    <div className="alert alert-info hint" dangerouslySetInnerHTML={{__html: this.props.schema.extra.hint }} />
                )}
                <div className="input-group-cr">
                    <input ref={(input) => this.checkbox = input  } 
                       type="checkbox" 
                       disabled={disabled}
                       checked={value === '1'} 
                       onChange={this.onChange} />
                    {
                        description && (
                            <span className="btn btn-default" onClick={this.onClick} >
                                <span className="fa fa-question-circle-o fa-fw"></span>
                            </span>     
                        )
                    }
                </div>
                 { description && this.state.isOpen && (
                     <div  className="alert alert-warning" role="alert">{this.tr(description)}</div>
                 ) }
                 {errorText && (<Alert>{errorText}</Alert>)}
            </Field>
        );
    }
}

export function createCheckbox(schema: IControlSchema, api: ApiClient, dispatcher: IDispatcher = null, error: IControlError | undefined, visited: boolean): React.ReactElement<any> {
    return <Checkbox schema={schema as ICheckboxSchema} api={api} dispatcher={dispatcher} error={error} visited={visited}/>;
}



// WEBPACK FOOTER //
// ./src/components/controls/standart/Checkbox.tsx